import Cookies from 'js-cookie';
import * as FormControl from '../utils/form-controls';
import * as CONST from '../utils/constants';

// global window
const filterObj = CONST.globalProject.Filters;

// initial state
// object name must match specification name
const filters = {
	//Yahya ALani
	//9/1/2021
	//Change the dropdown states default value to all states upon load instead of Geo location value. Ticket#208002
	//StateCode: new FormControl.FilterGroup('StateCode', 'State', 'All States', Cookies.get('StateCode'), false, true, 'select'),	
	StateCode: new FormControl.FilterGroup('StateCode', 'State', 'All States', '', false, true, 'checkbox'),
	Zipcode: new FormControl.FilterGroup(
		'Zipcode', 'Zip Code', null, null, false, true, 'textbox',
		new FormControl.Textbox('')
	),
	Radius: new FormControl.FilterGroup('Radius', 'Radius (mi)', null, '25', false, true, 'select'),
	VirtualEvent: new FormControl.FilterGroup('IsVirtual', 'Virtual Events', 'Yes', '', false, true, 'checkbox'),
};

FormControl.assignFilters(filterObj, filters);

export { filters as default };